import React, { useEffect, useState, useRef } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import AppCheckBox from '@/ui/checkbox';
import ScrollView from '@/ui/scroll-view';
import planQuestionStore from './store';
import { runInAction } from 'mobx';

const CartItem = ({ item, disable, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={[
        'relative flex-shrink-0',
        'w-164px h-256px px-8px pt-8px pb-16px border-1px border-black bg-black bg-opacity-2 rounded-12px',
        item.check ? 'border-opacity-100' : 'border-opacity-10',
        disable ? '' : 'cursor-pointer hover:bg-opacity-3',
      ]}
    >
      <img
        src={item.cover}
        className="size-148px rounded-8px object-cover"
        alt=""
      />
      <div className="min-h-40px text-14px text-[#1F1F1F] leading-20px mt-12px mb-8px line-clamp-2">
        {item.name}
      </div>
      <div className="flex items-center w-full">
        <div className="flex-grow w-0 truncate flex items-center gap-2px">
          <span className="text-14px text-[#FF3B30] font-bold">￥</span>
          <span className="text-18px text-[#FF3B30] font-bold truncate">
            {item.price}
          </span>
        </div>
        <div className="w-36px h-18px bg-black bg-opacity-6 rounded-4px vh-center text-12px text-black text-opacity-50 ml-4px flex-shrink-0">
          {item.platform}
        </div>
      </div>
      <div className="absolute size-16px top-8px right-8px bg-white rounded-4px overflow-hidden">
        <AppCheckBox
          checked={item.check}
          className={['!size-16px flex-shrink', disable ? 'opacity-30' : '']}
        />
      </div>
    </div>
  );
};

const AddCart = observer(
  ({ list, planStepId, parentIndex, itemType, disable }) => {
    return (
      <div className="mb-12px">
        <ScrollView scrollX className="flex gap-16px w-full">
          {(list || []).map((item, index) => {
            return (
              <CartItem
                disable={disable}
                key={index}
                item={item}
                onClick={evt => {
                  if (disable) return;
                  const resItem = list.map(_item => {
                    runInAction(()=>{
                      if (item.id == _item.id) {
                        item.check = !item.check;
                      }
                    });
                    return _item;
                  });
                  planQuestionStore.updatePlanData(
                    planStepId,
                    itemType,
                    parentIndex,
                    'items',
                    resItem
                  );
                }}
              />
            );
          })}
        </ScrollView>
      </div>
    );
  }
);
export default AddCart;
